import api from './api';

export const getSubscriptionStatus = () =>
  api.get('/api/v1/subscription/status').then((r) => r.data.data);

export const getPlans = () =>
  api.get('/api/v1/subscription/plans').then((r) => r.data.data);

export const createCheckoutSession = (planId = 'solo') =>
  api.post('/api/v1/subscription/checkout', { planId }).then((r) => r.data.data);

export const createPortalSession = () =>
  api.post('/api/v1/subscription/portal').then((r) => r.data.data);
